export default __webpack_public_path__ + "static/media/bg_10.651946c9.png";